import { config } from '@fortawesome/fontawesome-svg-core'

config.mutateApproach = 'sync'
config.showMissingIcons = true;

